import { useTrackingEventsDatas } from "@/hooks";
import { useTrackingEvent } from "./useTrackingEvent";
export const useTrackingLeadInterestMail = (tracking) => {
    const EVENT_DATA = Object.assign({ event: "lead_classified_form_opened", av_zone: tracking.av_zone, av_feature: tracking.av_feature, av_contact_info_field: tracking.av_contact_info_field }, useTrackingEventsDatas({
        displayMedium: true,
        conversionType: "mail",
    }));
    return useTrackingEvent(EVENT_DATA);
};
